import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import * as moment from 'moment-timezone';

@Pipe({
    name: 'convertUtcNoTime',
    standalone: false
})
export class ConvertUtcNoTimePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {
  }

  transform(txt) {
    if (txt === undefined)
      return 'Never';
    txt = txt.replace(' ', 'T');
    const d = new Date(txt + 'Z');
    return d.toLocaleDateString('en-us', {});
  }

}
